import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';
import classNames from 'classnames';

const ContentSkeleton: React.FC<any> = () => {
  return (
    <div className="whitespace-nowrap overflow-hidden flex pt-0" style={{ flexFlow: 'wrap' }}>
      <div className={classNames('w-6/12  box-border pl-2 pr-1.5 mb-2')}>
        <div className="bg-surface-200-bg rounded-600 h-[304px] skeleton"></div>
      </div>

      {new Array(6).fill(0).map((_item, index) => {
        let isLeft = index / 2 === 0;
        return (
          <ProductCardSkeleton
            key={`skeleton-product-list-item-${index}`}
            className={classNames('w-6/12 box-border', { 'pl-2 pr-1': isLeft, 'pl-1 pr-2': !isLeft })}
          />
        );
      })}
    </div>
  );
};

export default ContentSkeleton;
